import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const APPOINTMENT_DURATION_SETTINGS_ENDPOINT = `${config.api.url}/organization/appointment-duration-settings`;

const formatApiErrorValue = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.filter(Boolean).join(' ');
  return JSON.stringify(value);
};

const handleSettingsResponse = async (res) => {
  if (res.ok) return handleResponse(res);

  const errorText = await res.text();
  let errorData = null;
  try {
    errorData = errorText ? JSON.parse(errorText) : null;
  } catch {
    errorData = null;
  }

  const validationErrors = errorData?.errors && typeof errorData.errors === 'object'
    ? Object.values(errorData.errors).flat().filter(Boolean).join(' ')
    : '';
  const message = (
    formatApiErrorValue(errorData?.message) ||
    formatApiErrorValue(errorData?.error) ||
    validationErrors ||
    errorText ||
    `HTTP error! status: ${res.status}`
  );

  const error = new Error(message);
  error.status = res.status;
  error.statusText = res.statusText;
  if (errorData?.errors && typeof errorData.errors === 'object') {
    error.fieldErrors = errorData.errors;
  }
  throw error;
};

const appointmentDurationSettingsApi = {
  getSettings: async () => {
    const res = await fetch(APPOINTMENT_DURATION_SETTINGS_ENDPOINT, {
      headers: getAuthHeaders(),
    });
    return handleResponse(res);
  },

  updateSettings: async (settings) => {
    const res = await fetch(APPOINTMENT_DURATION_SETTINGS_ENDPOINT, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(settings),
    });
    return handleSettingsResponse(res);
  },
};

export default appointmentDurationSettingsApi;
